import { StringEnum } from "../../utils/string-enum.js";

//#region src/shared/bricks/props/align.ts
function justifyContent(options = {}) {
	return StringEnum([
		"justify-start",
		"justify-center",
		"justify-end",
		"justify-between",
		"justify-around",
		"justify-evenly"
	], {
		enumNames: [
			"Start",
			"Center",
			"End",
			"Between",
			"Around",
			"Evenly"
		],
		title: "Justify bricks",
		"ui:field": "justify-content",
		"ui:responsive": true,
		"ui:styleId": "styles:justifyContent",
		examples: ["justify-center", "justify-evenly"],
		...options
	});
}
function alignItems(options = {}) {
	return StringEnum([
		"items-start",
		"items-center",
		"items-end",
		"items-stretch"
	], {
		enumNames: [
			"Start",
			"Center",
			"End",
			"Stretch"
		],
		title: "Align bricks",
		"ui:field": "align-items",
		"ui:responsive": true,
		"ui:styleId": "styles:alignItems",
		examples: ["items-center", "items-stretch"],
		...options
	});
}
function alignSelf(options = {}) {
	return StringEnum([
		"self-auto",
		"self-start",
		"self-center",
		"self-end",
		"self-stretch"
	], {
		enumNames: [
			"Auto",
			"Start",
			"Center",
			"End",
			"Stretch"
		],
		default: "self-auto",
		title: "Align self",
		"ui:field": "align-self",
		"ui:responsive": true,
		"ui:styleId": "styles:alignSelf",
		...options
	});
}

//#endregion
export { alignItems, alignSelf, justifyContent };
//# sourceMappingURL=align.js.map